import { lazily } from '@mk/core'

const { UserCenter, UserInfo, UserSetting } = lazily(() => import('@/features/user'))

/**
 * 用户路由
 */
export default [
  {
    id: Symbol('user'),
    path: '/user',
    element: <UserCenter />,
    children: [
      {
        id: Symbol('user'),
        path: 'uploader',
        handle: {
          isPublic: true
        },
        element: <UserInfo />
      },
      {
        id: Symbol('user'),
        path: 'info',
        handle: {
          isPublic: true
        },
        element: <UserInfo />
      },
      {
        id: Symbol('user'),
        path: 'setting',
        handle: {
          isPublic: true
        },
        element: <UserSetting />
      }
    ]
  }
]
